import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const TourProgressBoxWrapper = styled.div`
  background: var(--color-bg-body);
  border-radius: var(--size-border-radius-xl);
  bottom: 6px;
  box-shadow: var(--shadow-m);
  left: calc(100% + 10px);
  padding: 16px;
  position: absolute;
  width: 360px;
`;

const ProgressArea = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 16px;
`;

const AreaLabel = styled(Typography)`
  margin-left: 32px;
  word-break: keep-all;
`;

const BoxHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const BoxBody = styled.div``;

const ProgressBody = styled.div`
  border: 1px solid var(--color-accent-primary-weak);
  border-radius: var(--size-border-radius-xl);
`;

export { AreaLabel, BoxBody, BoxHeader, ProgressArea, ProgressBody, TourProgressBoxWrapper };
